<script lang="ts">
  import Info from "./Info.svelte";
  export let title = "";
  export let message = "Loading";
</script>

<Info class="loading" {title} {message} />
